import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Div } from "../../../../../registroMaternidad/modales/components/Components";
import InputText from "../../../../../../components/modalComponents/InputText";
import ModalForm from "../../../../../../components/modalComponents/ModalForm";
import { useManagePostRequest } from "../../../../../../hooks/useManagePostRequest/useManagePostRequest";
import {
  cuadroRequerimientosCompletarTarea,
  cuadroRequerimientosAgregarMensaje,
  cuadroRequerimientosGetCasoHistorialChat,
  cuadroRequerimientosCerrarCambioAprobado,
  cuadroRequerimientosCerrarCambioRechazado,
} from "../../../../../../consumers/backendApisUrls";

import { faComment, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
const SeccionTareas = styled.div`
  margin: 16px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const FilaTarea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #333;
`;

const BtnCompletar = styled.button`
  padding: 5px 14px;
  border: none;
  border-radius: 15px;
  font-size: 13px;
  font-weight: 500;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  background-color: ${({ disabled }) => (disabled ? "#9ca3af" : "#1a7fc4")};
  color: #fff;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: #0069d9;
  }
`;

const SeccionHistorial = styled.div`
  margin-top: 14px;
  background: #f5f6f8;
  border-radius: 8px;
  padding: 12px;
`;

const HistorialToggle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
`;

const HistorialItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fff;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
`;

const Avatar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #6b7280;
  font-size: 14px;
`;

const HistorialTexto = styled.div`
  font-size: 13px;
  color: #374151;

  .autor {
    font-weight: 600;
    margin-bottom: 2px;
  }
  .mensaje {
    color: #6b7280;
  }
`;

const FooterComentario = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
`;

const InputComentario = styled.input`
  flex: 1;
  border: none;
  background: #f5f6f8;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 13px;
  color: #374151;
  outline: none;

  &::placeholder {
    color: #9ca3af;
  }
`;

const BtnEnviar = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  color: #1a7fc4;
  font-size: 18px;
  display: flex;
  align-items: center;

  &:hover {
    color: #0069d9;
  }
`;

const formatFecha = (fecha) => {
  if (!fecha) return "";
  return new Date(fecha).toLocaleDateString("es-PE");
};

const LABEL_REFERENCIA = {
  Docente: "Referencia (Docente)",
  Bloque: "Referencia (Bloque)",
};

const DetalleSolicitudCambioModal = ({
  toggleModal,
  refreshPage,
  casoData,
}) => {
  const SECTION_NAME = "DetalleSolicitudCambio";

  const [historialVisible, setHistorialVisible] = useState(true);
  const [comentario, setComentario] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const tareas = (casoData?.Detalles ?? [])
    .filter((d) => d.TipoDetalle === "Tarea")
    .sort((a, b) => (a.OrdenTarea ?? 0) - (b.OrdenTarea ?? 0));

  const [historial, setHistorial] = useState([]);

  const [executeManagePost] = useManagePostRequest();

  const cargarHistorial = async () => {
    await executeManagePost(
      cuadroRequerimientosGetCasoHistorialChat(),
      { IdCaso: Number(casoData?.IdCaso) },
      ({ data }) => setHistorial(data ?? []),
    );
  };

  const handleCompletarTarea = async (idCasoDetalle) => {
    setIsSubmitting(true);
    await executeManagePost(
      cuadroRequerimientosCompletarTarea(),
      { IdCaso: casoData.IdCaso, IdCasoDetalle: idCasoDetalle },
      async () => {
        await refreshPage();
        toggleModal();
      },
    );
    setIsSubmitting(false);
  };

  const handleEnviarComentario = async () => {
    if (!comentario.trim()) return;
    setIsSubmitting(true);
    await executeManagePost(
      cuadroRequerimientosAgregarMensaje(),
      { IdCaso: casoData.IdCaso, Contenido: comentario },
      () => {
        setComentario("");
        cargarHistorial();
        refreshPage();
      },
    );
    setIsSubmitting(false);
  };
  const handleCerrarAprobado = async () => {
    try {
      await executeManagePost(
        cuadroRequerimientosCerrarCambioAprobado(),
        {
          IdCaso: Number(casoData?.IdCaso),
          Resolucion: "Aprobado",
          IdUsuario: 1,
        },
        async () => {
          await refreshPage();
          toggleModal();
        },
      );
    } catch (error) {
      console.error("Error al bloquear empleado:", error);
    }
  };
  const handleCerrarRechazado = async () => {
    try {
      await executeManagePost(
        cuadroRequerimientosCerrarCambioRechazado(),
        {
          IdCaso: Number(casoData?.IdCaso),
          Resolucion: "Rechazado",
          IdUsuario: 1,
        },
        async () => {
          await refreshPage();
          toggleModal();
        },
      );
    } catch (error) {
      console.error("Error al bloquear empleado:", error);
    }
  };
  useEffect(() => {
    cargarHistorial();
  }, []);

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <ModalForm
      titulo="Ver Detalle - Solicitud"
      width="650px"
      showModal={toggleModal}
      hasSaveButton={false}
    >
      <div className="displayFlexWrap">
        <Div col={12}>
          <InputText
            label="Tema"
            name="Tema"
            value={casoData?.Tema ?? ""}
            onChange={() => {}}
            sectionName={SECTION_NAME}
            direction="column"
            isDisabled={true}
          />
        </Div>

        <Div col={6}>
          <InputText
            label="Tipo Caso"
            name="TipoCaso"
            value={casoData?.TipoCaso ?? ""}
            onChange={() => {}}
            sectionName={SECTION_NAME}
            direction="column"
            isDisabled={true}
          />
        </Div>
        <Div col={6}>
          <InputText
            label="Fecha"
            name="Fecha"
            value={formatFecha(casoData?.FechaRegistro)}
            onChange={() => {}}
            sectionName={SECTION_NAME}
            direction="column"
            isDisabled={true}
          />
        </Div>

        <Div col={6}>
          <InputText
            label="Responsable"
            name="Responsable"
            value={casoData?.NombreResponsable ?? ""}
            onChange={() => {}}
            sectionName={SECTION_NAME}
            direction="column"
            isDisabled={true}
          />
        </Div>
        <Div col={6}>
          <InputText
            label="Estado"
            name="Estado"
            value={casoData?.EstadoResolucion ?? casoData?.EstadoCaso ?? ""}
            onChange={() => {}}
            sectionName={SECTION_NAME}
            direction="column"
            isDisabled={true}
          />
        </Div>

        <Div col={6}>
          <InputText
            label="Tipo referencia"
            name="TipoReferencia"
            value={casoData?.TipoReferencia ?? ""}
            onChange={() => {}}
            sectionName={SECTION_NAME}
            direction="column"
            isDisabled={true}
          />
        </Div>
        <Div col={6}>
          <InputText
            label={LABEL_REFERENCIA[casoData?.TipoReferencia] ?? "Referencia"}
            name="Referencia"
            value={casoData?.Referencia ?? ""}
            onChange={() => {}}
            sectionName={SECTION_NAME}
            direction="column"
            isDisabled={true}
          />
        </Div>

        <Div col={12}>
          <SeccionTareas>
            {tareas.map((tarea) => {
              const isPendiente = tarea.EstadoTarea === "PENDIENTE";
              return (
                <FilaTarea key={tarea.IdCasoDetalle}>
                  <span>
                    Tarea {tarea.OrdenTarea}: {tarea.Contenido}
                  </span>
                  <BtnCompletar
                    disabled={!isPendiente || isSubmitting}
                    onClick={() =>
                      isPendiente && handleCompletarTarea(tarea.IdCasoDetalle)
                    }
                  >
                    Completar
                  </BtnCompletar>
                </FilaTarea>
              );
            })}
          </SeccionTareas>
        </Div>

        <Div col={6}>

        </Div>
        <Div col={3}>
          {casoData.PuedeAprobarRechazarResolverCompletarActivarInactivarRecibir && (
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="generic-button-buscador btn-danger"
                onClick={() => handleCerrarRechazado()}
                style={{
                  backgroundColor: "#dc3545",
                  color: "white",
                  border: "1px solid #dc3545",
                }}
              >
                Rechazar
              </button>
            </div>
          )}
        </Div>
        <Div col={3}>
          {casoData.PuedeAprobarRechazarResolverCompletarActivarInactivarRecibir && (
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="generic-button-buscador"
                onClick={() => handleCerrarAprobado()}
              >
                Aprobar
              </button>
            </div>
          )}
        </Div>

        <Div col={12}>
          <SeccionHistorial>
            <HistorialToggle
              onClick={() => setHistorialVisible(!historialVisible)}
            >
              <FontAwesomeIcon icon={faComment} />
              Conversación
              <FontAwesomeIcon
                icon={historialVisible ? "caret-down" : "caret-right"}
                size="sm"
              />
            </HistorialToggle>

            {historialVisible &&
              historial.map((h, i) => (
                <HistorialItem key={i}>
                  <Avatar>
                    <FontAwesomeIcon icon="user" size="sm" />
                  </Avatar>
                  <HistorialTexto>
                    <div className="autor">
                      {h.NombreUsuario}
                      <span
                        style={{
                          fontWeight: 400,
                          color: "#9ca3af",
                          fontSize: 11,
                          marginLeft: 8,
                        }}
                      >
                        {h.FechaRegistro
                          ? new Date(h.FechaRegistro).toLocaleString("es-PE", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            })
                          : ""}
                      </span>
                    </div>
                    <div className="mensaje">{h.Observacion}</div>
                  </HistorialTexto>
                </HistorialItem>
              ))}
          </SeccionHistorial>
        </Div>

        {casoData.PuedeEnviarMensaje && (
          <Div col={12}>
            <FooterComentario>
              <Avatar>
                <FontAwesomeIcon icon="user" size="sm" />
              </Avatar>
              <InputComentario
                placeholder={`Comentar como ${casoData?.NombreResponsable ?? "usuario"}`}
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleEnviarComentario()}
              />
              <BtnEnviar
                type="button"
                onClick={handleEnviarComentario}
                disabled={isSubmitting}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
              </BtnEnviar>
            </FooterComentario>
          </Div>
        )}
      </div>
    </ModalForm>
  );
};

DetalleSolicitudCambioModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  refreshPage: PropTypes.func.isRequired,
  casoData: PropTypes.object.isRequired,
};

export default DetalleSolicitudCambioModal;
